import styled from 'styled-components';

export const ElementWrapper = styled.div`
  font-size: 2.5rem;
  color: #fdab29;
  width: 11rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
`;
export const IconNextPre = styled.img`
  width: 2.125rem;
  height: 2.125rem;
  cursor: pointer;
  margin-top: 2rem;
`;
export const IconSpace = styled.div`
  width: 2.125rem;
  height: 2.125rem;
  margin-top: 2rem;
`;
export const DayWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  font-weight: 500;
`;
export const WeekChangeWrapper = styled.div`
  margin-left: 10rem;
`;
export const ContainerWeekView = styled.div`
  width: 77.5rem;
  display: flex;
  flex-direction: column;
`;
export const DayItem = styled.span`
  font-size: 1.7rem !important;
  margin-left: 0.5rem;
`;
